import React from 'react';
import { t } from '@lingui/macro';
import { PageBody, PageHeader } from 'components/PageLayout';
import PageHeading from 'components/PageHeading';
import { withErrorBoundary } from 'error';
import { FiltersParams } from 'types/params';
import { ListFilters } from 'components/ListFilters/ListFilters';
import { RoutePaths } from 'types/enums';
import { PageBreadcrumbs } from 'components/PageBreadcrumbs/PageBreadcrumbs';
import { usePrerenderComponentsRequired } from 'hooks/usePrerenderComponentsRequired/usePrerenderComponentsRequired';

const Sfxs: React.FC = () => {
    usePrerenderComponentsRequired({ componentNames: ['ListFilters'] });

    return (
        <>
            <PageHeader>
                <PageHeading
                    title={t`Browse Sound Effects`}
                    byline={t`Find the best royalty-free sound effects in every category including Voices, Ambience, Industrial, Environment and more.`}
                />
            </PageHeader>
            <PageBody>
                <ListFilters
                    path={RoutePaths.Sfxs}
                    filterParams={FiltersParams.sfxs}
                />
            </PageBody>
            <PageBreadcrumbs
                breadcrumbs={[
                    { route: RoutePaths.ForYou, label: t`Home` },
                    {
                        route: RoutePaths.Sfxs,
                        label: t`Sfxs`,
                        isCurrent: true,
                    },
                ]}
            />
        </>
    );
};

Sfxs.displayName = 'Sfxs';

export default withErrorBoundary(Sfxs, 'page');
